var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 90,
    viewBox: "0 0 93 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17.9072V14.7498H15V12Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4059 22.2112L77.4618 24.156L80.9303 27.6244H68.1776V13.0063H65.4277V30.3743H80.9303L77.4618 33.8428L79.4059 35.7875L86.194 28.9994L79.4059 22.2112Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7322 25.9447L12.7881 24L6 30.7881L12.7881 37.5763L14.7322 35.6315L11.2637 32.1631H24.0164V46.7819H26.7663V29.4132H11.2637L14.7322 25.9447Z",
    fill: "#191919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5322 7.27002H62.4401V10.0199H59.5322V7.27002Z",
    fill: "#191919"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8936 72.5384V0H59.5326V2.74984H90.1437V55.2498H28.9995V57.999H90.1437V69.7885H2.74984V57.999H24.638V55.2498H2.74984V2.74984H55.1704V0H0V72.5384H31.9867V81.4201H26.171V89.9857H49.3547V87.2359H28.9208V84.1699H63.9728V87.2359H53.7162V89.9857H66.7226V81.4201H60.9068V72.5384H92.8936ZM34.7366 81.4201V72.5384H58.157V81.4201H34.7366Z",
    fill: "#191919"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8154 49.6245H14.7226V52.3744H11.8154V49.6245Z",
    fill: "#191919"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3609 13.0854H30.5322V44.9141H62.3609V13.0854ZM43.46 24.5589H49.4338V27.6249H43.46V24.5589ZM49.4338 15.8353V21.8091H43.46V15.8353H49.4338ZM59.6111 42.1643H33.2821V15.8353H40.7102V30.3747H52.183V15.8353H59.6111V42.1643Z",
    fill: "#191919"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H11.9079V14.7498H9V12Z",
    fill: "#191919"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8096 34.8945H53.7167V37.6444H50.8096V34.8945Z",
    fill: "#191919"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H23.9079V12.7498H21V10Z",
    fill: "#191919"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3477 7.27002H68.2555V10.0199H65.3477V7.27002Z",
    fill: "#191919"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7158 7.27002H56.6237V10.0199H53.7158V7.27002Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.8e612831e15185a215bec5c3e523ac18.svg";
export { ForwardRef as ReactComponent };